<template>
  <div class="page">
    <div class="header">
      <div class="description">
        <h1 class="title">Adicionar Consulta ao Template "{{ template.name }}"</h1>
      </div>
    </div>

    <new-query
      :tag="template.tag"
      :template="template"
      consultations-route="/template/others"
    />
  </div>
</template>

<script>
import NewQuery from '@/template/components/NewQuery.vue';
import { mapState } from 'vuex';

export default {
  name: 'Create',

  data() {
    return {
      loading: false,
    };
  },

  components: {
    NewQuery,
  },

  computed: {
    ...mapState('template', [
      'template',
    ]),
  },

  methods: {
    async loadTemplate() {
      await this.$store.dispatch('template/fetchTemplate', this.$route.params.id);
    },

    async submitForm() {
      return !!(await this.$refs.form.validate());
    },
  },

  filters: {
  },

  mounted() {
    try {
      this.loading = true;

      this.loadTemplate();
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
